import React from 'react';

import { Translate } from 'core/translate';

type Props = {
  className?: string;
  transportation: string;
  time: number;
};

function Transportation({ className, transportation, time }: Props) {
  const common = { nearby_terminal_transportation: transportation };
  let translateId: string;
  let data;

  if (time < 60) {
    translateId = 'Traveler_Common.Nearby_Terminal.Minutes';
    data = {
      ...common,
      nearby_terminal_time_required_minutes: time,
    };
  } else if (time % 60 === 0) {
    translateId = 'Traveler_Common.Nearby_Terminal.Hours';
    data = { ...common, nearby_terminal_time_required_hours: Math.floor(time / 60) };
  } else {
    translateId = 'Traveler_Common.Nearby_Terminal.Hours_Minutes';
    data = {
      ...common,
      nearby_terminal_time_required_hours: Math.floor(time / 60),
      nearby_terminal_time_required_minutes: time % 60,
    };
  }

  return (
    <Translate
      id={translateId}
      data={data}
      className={className}
      data-testid="providerInfo-transportation-wrapper"
    />
  );
}

export default Transportation;
